import React from 'react';
import InfoList from '@components/position/jd/companyInfo/infoList';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import TextUtil from '@utils/text/util';
import classnames from 'classnames/bind';
import styles from './companyInfo.module.scss';
const cx = classnames.bind(styles);

interface CompanyInfoProps {
  positionDetail: PositionDetailVO;
}

const CompanyInfo = ({ positionDetail }: CompanyInfoProps) => {
  const { companyInfo } = positionDetail;
  const { companyName, lastModifiedDateText } = companyInfo;

  return (
    <div className={cx('companyInfoWrap')}>
      <div className={cx('titleArea')}>
        <em className={cx('title')}>
          {companyName}
          {TextUtil.isBatchimEnding(companyName) ? '을' : '를'} 소개합니다!
        </em>
        <span className={cx('update')}>{lastModifiedDateText}</span>
      </div>
      <InfoList positionDetail={positionDetail} />
    </div>
  );
};

export default CompanyInfo;
